import { NgModule } from '@angular/core';
import type { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import { CanDeactivateGuardService } from '../rcr-exchange/services/can-deactivate-guard.service';
import { AllocatePoolsComponent } from './allocate-pools/allocate-pools.component';
import { BulkUploadConfirmationPageComponent } from './bulk-upload-confirmation-page/bulk-upload-confirmation-page.component';
import { BulkUploadMegasContainerComponent } from './bulk-upload-megas-container/bulk-upload-megas-container.component';
import { BulkUploadMegasAgComponent } from './bulk-upload-megas-ag/bulk-upload-megas-ag.component';
import { BulkUploadReviewAndCommitComponent } from './bulk-upload-review-and-commit/bulk-upload-review-and-commit.component';
import { CollateralAnalyzerConfirmationComponent } from './collateral-analyzer-confirmation/collateral-analyzer-confirmation.component';
import { CollateralAnalyzerReviewAndCommitComponent } from './collateral-analyzer-review-and-commit/collateral-analyzer-review-and-commit.component';
import { CollateralAnalyzerUploadFileComponent } from './collateral-analyzer-upload-file/collateral-analyzer-upload-file.component';
import { CommittedMegaComponent } from './committed-mega/committed-mega.component';
import { ConfirmationPageComponent } from './confirmation-page/confirmation-page.component';
import { EnterMegaTradeDetailsComponent } from './enter-mega-trade-details/enter-mega-trade-details-component';
import { BulkUploadMegaCanNavigateGuard } from './guards/bulk-upload-mega-can-navigate-guard';
import { MegaTradeRouteGuard } from './guards/mega-can-navigate.guard';
import { MegaUploadPoolTradeRouteGuard } from './guards/mega-upload-pool-can-navigate.guard';
import { MegaTradeContainerComponent } from './mega-trade-container/mega-trade-container';
import { ReviewAndCommitComponent } from './review-and-commit/review-and-commit.component';
import { MegaTradeNavigationService } from './services/mega-trade-navigation.service';
import { SettledMegasComponent } from './settled-megas/settled-megas.component';
import { UploadPoolConfirmationPageComponent } from './upload-pool-confirmation-page/upload-pool-confirmation-page.component';
import { UploadPoolInfoContainerComponent } from './upload-pool-info-container/upload-pool-info-container.component';
import { UploadPoolInfoComponent } from './upload-pool-info/upload-pool-info.component';
import { ValidatePoolsComponent } from './vadidate-pools/validate-pools.component';

const megaFeatureRoutes: Routes = [
  {
    path: 'mega-trade',
    component: MegaTradeContainerComponent,
    children: [
      {
        path: '',
        canActivateChild: [MegaTradeRouteGuard],
        children: [
          {
            path: 'enter-details',
            component: EnterMegaTradeDetailsComponent,
            canDeactivate: [CanDeactivateGuardService],
          },

          {
            path: 'enter-details/review-and-commit',
            component: ReviewAndCommitComponent,
            canDeactivate: [CanDeactivateGuardService],
          },
          {
            path: 'enter-details/confirmation',
            component: ConfirmationPageComponent,
            canDeactivate: [CanDeactivateGuardService],
          },
        ],
      },
    ],
  },
  {
    path: 'mega-upload',
    component: UploadPoolInfoContainerComponent,
    children: [
      {
        path: '',
        canActivateChild: [MegaUploadPoolTradeRouteGuard],
        children: [
          {
            path: 'upload-pool-info',
            component: UploadPoolInfoComponent,
            canDeactivate: [CanDeactivateGuardService],
          },
          {
            path: 'upload-pool-info/validate-pools',
            component: ValidatePoolsComponent,
            canDeactivate: [CanDeactivateGuardService],
          },
          {
            path: 'upload-pool-info/allocate-pools',
            component: AllocatePoolsComponent,
            canDeactivate: [CanDeactivateGuardService],
          },
          {
            path: 'upload-pool-info/confirmation',
            component: UploadPoolConfirmationPageComponent,
            canDeactivate: [CanDeactivateGuardService],
          },
        ],
      },
    ],
  },
  {
    path: 'bulk-upload',
    component: BulkUploadMegasContainerComponent,
    children: [
      {
        path: '',
        canActivateChild: [BulkUploadMegaCanNavigateGuard],
        children: [
          {
            path: 'enter-mega-details',
            component: BulkUploadMegasAgComponent,
            canDeactivate: [CanDeactivateGuardService],
          },

          {
            path: 'enter-mega-details/review-and-commit',
            component: BulkUploadReviewAndCommitComponent,
            canDeactivate: [CanDeactivateGuardService],
          },
          {
            path: 'enter-mega-details/confirmation',
            component: BulkUploadConfirmationPageComponent,
            canDeactivate: [CanDeactivateGuardService],
          },
        ],
      },
    ],
  },
  {
    path: 'collateral-analyzer',
    children: [
      {
        path: '',
        // canActivateChild: [CollateralSandboxRouteGuard],
        children: [
          {
            path: 'file-upload',
            component: CollateralAnalyzerUploadFileComponent,
            //canDeactivate: [CanDeactivateGuardService]
          },

          {
            path: 'review-and-commit',
            component: CollateralAnalyzerReviewAndCommitComponent,
            //  canDeactivate: [CanDeactivateGuardService]
          },
          {
            path: 'confirmation',
            component: CollateralAnalyzerConfirmationComponent,
            // canDeactivate: [CanDeactivateGuardService]
          },
        ],
      },
    ],
  },
  {
    path: 'mega-trade/settled-megas',
    component: SettledMegasComponent,
  },
  {
    path: 'mega-trade/committed-mega',
    component: CommittedMegaComponent,
    canDeactivate: [CanDeactivateGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(megaFeatureRoutes)],
  providers: [MegaTradeNavigationService],
  exports: [RouterModule],
})
export class MegaTradeRoutingModule {}
